import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "header pb-6 d-flex align-items-center profile-header" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "mask bg-gradient-default opacity-8" }, null, -1)
const _hoisted_3 = { class: "container-fluid d-flex align-items-center" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-lg-7 col-md-10" }
const _hoisted_6 = { class: "display-2 text-white" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "text-white mt-0 mb-5" }, " Esta es la página de tu perfil. Puedes ver todos tus datos y modificarlos si gustas, además de encontrar algunas configuraciones que se adapten mejor para ti. ", -1)
const _hoisted_8 = { class: "container-fluid mt--6" }
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "col-xl-4 order-xl-2" }
const _hoisted_11 = { class: "col-xl-8 order-xl-1" }

import { computed } from "vue";
import { AuthModule } from "@/store/modules/Auth";
// Components
import UserCard from "./UserProfile/UserCard.vue";
import EditProfileForm from "./UserProfile/EditProfileForm.vue";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

// State
const user = computed(() => AuthModule.user);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("h1", _hoisted_6, "Hola " + _toDisplayString(_unref(user)?.name), 1),
            _hoisted_7
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createVNode(UserCard)
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createVNode(EditProfileForm)
        ])
      ])
    ])
  ]))
}
}

})